<!-- Modal Backdrop -->
@if (isOpen) {
  <div class="modal-backdrop fade show"></div>
}

<!-- Modal -->
@if (isOpen) {
  <div class="modal fade show d-block" tabindex="-1" role="dialog" style="z-index: 1050;">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <div>
            <h4 class="modal-title mb-1">
              <i class="bi bi-truck-front text-primary me-2"></i>Trucking Charges
            </h4>
            <p class="text-muted small mb-0">Manage inland transportation and delivery fees (Code: TK)</p>
          </div>
          <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <!-- Statistics Cards -->
          <div class="row g-3 mb-4">
            <div class="col-6 col-md-3">
              <div class="card stat-card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <i class="bi bi-truck-front text-primary fs-4 me-2"></i>
                    <div>
                      <p class="text-muted mb-0 small">Total Charges</p>
                      <h3 class="mb-0">{{ stats.totalCharges }}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 col-md-3">
              <div class="card stat-card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <i class="bi bi-check-circle text-success fs-4 me-2"></i>
                    <div>
                      <p class="text-muted mb-0 small">Mandatory</p>
                      <h3 class="mb-0">{{ stats.mandatoryCharges }}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 col-md-3">
              <div class="card stat-card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <i class="bi bi-circle text-warning fs-4 me-2"></i>
                    <div>
                      <p class="text-muted mb-0 small">Optional</p>
                      <h3 class="mb-0">{{ stats.optionalCharges }}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-6 col-md-3">
              <div class="card stat-card">
                <div class="card-body">
                  <div class="d-flex align-items-center">
                    <i class="bi bi-currency-dollar text-info fs-4 me-2"></i>
                    <div>
                      <p class="text-muted mb-0 small">Avg Price</p>
                      <h3 class="mb-0">&#x20B1;{{ stats.averagePrice | number:'1.0-0' }}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Filter Section -->
          <div class="card mb-3">
            <div class="card-body">
              <div class="row g-3">
                <div class="col-12 col-md-6">
                  <div class="input-group">
                    <span class="input-group-text"><i class="bi bi-search"></i></span>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Search fee name or description..."
                      [(ngModel)]="searchTerm"
                      (input)="applyFilters()">
                  </div>
                </div>
                <div class="col-6 col-md-3">
                  <select class="form-select" [(ngModel)]="selectedMode" (change)="applyFilters()">
                    <option value="">All Modes</option>
                    <option value="ALL">ALL</option>
                    <option value="SEA_LCL">SEA (LCL)</option>
                    <option value="SEA_FCL">SEA (FCL)</option>
                    <option value="SEA_ALL">SEA (ALL)</option>
                    <option value="AIR">AIR</option>
                  </select>
                </div>
                <div class="col-6 col-md-3">
                  <select class="form-select" [(ngModel)]="selectedChargeType" (change)="applyFilters()">
                    <option value="">All Charge Rates</option>
                    <option value="Flat Rate">Flat Rate</option>
                    <option value="Percentage">Percentage</option>
                    <option value="Manual Input">Manual Input</option>
                    <option value="Agent Based">Agent Based</option>
                    <option value="Auto-Calculated">Auto-Calculated</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <!-- Add Button -->
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">Trucking Charges ({{ filteredCharges.length }})</h5>
            <button class="btn btn-primary" (click)="openAddForm()">
              <i class="bi bi-plus-circle"></i> Add Trucking Charge
            </button>
          </div>

          <!-- Data Table -->
          <div class="table-responsive">
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Fee Name</th>
                  <th>Mode</th>
                  <th>Charge Basis</th>
                  <th>Default Price</th>
                  <th>Charge Rate</th>
                  <th>Optional?</th>
                  <th>Port Application</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @for (charge of filteredCharges; track charge.id) {
                  <tr>
                    <td>
                      <i class="bi bi-circle-fill text-primary me-2" style="font-size: 8px;"></i>
                      {{ charge.feeName }}
                    </td>
                    <td>
                      <span class="badge" [ngClass]="{
                        'bg-info': charge.mode === 'SEA_LCL',
                        'bg-primary': charge.mode === 'SEA_FCL',
                        'bg-success': charge.mode === 'SEA_ALL',
                        'bg-warning text-dark': charge.mode === 'AIR',
                        'bg-secondary': charge.mode === 'ALL'
                      }">
                        {{ getModeDisplay(charge.mode) }}
                      </span>
                    </td>
                    <td class="small">{{ charge.chargeBasis }}</td>
                    <td>
                      <strong>{{ charge.currency === 'PHP' ? '&#x20B1;' : '$' }}{{ charge.defaultPrice | number:'1.0-0' }}</strong>
                    </td>
                    <td>
                      <span class="badge bg-info">{{ charge.chargeType }}</span>
                    </td>
                    <td>
                      <span class="badge" [ngClass]="charge.isOptional ? 'bg-warning text-dark' : 'bg-success'">
                        {{ charge.isOptional ? 'Optional' : 'Mandatory' }}
                      </span>
                    </td>
                    <td>{{ charge.portApplication }}</td>
                    <td>
                      <div class="btn-group btn-group-sm">
                        <button class="btn btn-outline-primary" (click)="editCharge(charge)" title="Edit">
                          <i class="bi bi-pencil"></i>
                        </button>
                        <button class="btn btn-outline-danger" (click)="deleteCharge(charge)" title="Delete">
                          <i class="bi bi-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                } @empty {
                  <tr>
                    <td colspan="8" class="text-center text-muted py-4">
                      No trucking charges found. Click "Add Trucking Charge" to create one.
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Add/Edit Form Modal (Nested) -->
@if (showForm) {
  <div class="modal-backdrop fade show" style="z-index: 1055 !important; background-color: rgba(0, 0, 0, 0.85) !important;"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" style="z-index: 1056 !important;">
    <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ isEditMode ? 'Edit' : 'Add' }} Trucking Charge</h5>
          <button type="button" class="btn-close" (click)="closeForm()"></button>
        </div>
        <div class="modal-body">
          <form>
            <!-- Fee Name -->
            <div class="mb-3">
              <label class="form-label">Fee Name <span class="text-danger">*</span></label>
              <input type="text" class="form-control" [(ngModel)]="formData.feeName" name="feeName" required>
            </div>

            <!-- Mode -->
            <div class="mb-3">
              <label class="form-label">Mode <span class="text-danger">*</span></label>
              <select class="form-select" [(ngModel)]="formData.mode" name="mode" required>
                <option value="ALL">ALL</option>
                <option value="SEA_LCL">SEA (LCL)</option>
                <option value="SEA_FCL">SEA (FCL)</option>
                <option value="SEA_ALL">SEA (ALL)</option>
                <option value="AIR">AIR</option>
              </select>
            </div>

            <!-- Charge Type -->
            <div class="mb-3">
              <label class="form-label">Charge Rate <span class="text-danger">*</span></label>
              <select class="form-select" [(ngModel)]="formData.chargeType" name="chargeType" required>
                <option value="Flat Rate">Flat Rate</option>
                <option value="Percentage">Percentage</option>
                <option value="Manual Input">Manual Input</option>
                <option value="Agent Based">Agent Based</option>
                <option value="Auto-Calculated">Auto-Calculated</option>
              </select>
            </div>

            <!-- Port Application -->
            <div class="mb-3">
              <label class="form-label">Applies To Port <span class="text-danger">*</span></label>
              <select class="form-select" [(ngModel)]="formData.portApplication" name="portApplication" required>
                <option value="Origin">Origin</option>
                <option value="Destination">Destination</option>
                <option value="Both">Both</option>
                <option value="N/A">N/A</option>
              </select>
            </div>

            <!-- Currency -->
            <div class="mb-3">
              <label class="form-label">Currency <span class="text-danger">*</span></label>
              <select class="form-select" [(ngModel)]="formData.currency" name="currency" required>
                <option value="PHP">PHP (&#x20B1;)</option>
                <option value="USD">USD ($)</option>
              </select>
            </div>

            <!-- Default Price -->
            <div class="mb-3">
              <label class="form-label">Default Price ({{ formData.currency }}) <span class="text-danger">*</span></label>
              <input type="number" class="form-control" [(ngModel)]="formData.defaultPrice" name="defaultPrice" required>
            </div>

            <!-- Charge Basis -->
            <div class="mb-3">
              <label class="form-label">Charge Basis <span class="text-danger">*</span></label>
              <select class="form-select" [(ngModel)]="formData.chargeBasis" name="chargeBasis" required>
                <option value="">-- Select Charge Basis --</option>
                @for (basis of chargeBasisList; track basis.id) {
                  <option [value]="basis.displayName">{{ basis.displayName }}</option>
                }
              </select>
            </div>

            <!-- Description -->
            <div class="mb-3">
              <label class="form-label">Description</label>
              <textarea class="form-control" rows="2" [(ngModel)]="formData.description" name="description"
                placeholder="Optional description or notes"></textarea>
            </div>

            <!-- Toggles -->
            <div class="row">
              <div class="col-4">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="formData.isOptional" name="isOptional" id="tk_isOptional">
                  <label class="form-check-label small" for="tk_isOptional">
                    Optional<br>
                    <span class="text-muted" style="font-size: 0.75rem;">Can be excluded</span>
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="formData.isAgentSpecific" name="isAgentSpecific" id="tk_isAgentSpecific">
                  <label class="form-check-label small" for="tk_isAgentSpecific">
                    Agent Specific<br>
                    <span class="text-muted" style="font-size: 0.75rem;">Has agent overrides</span>
                  </label>
                </div>
              </div>
              <div class="col-4">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="formData.isTaxable" name="isTaxable" id="tk_isTaxable">
                  <label class="form-check-label small" for="tk_isTaxable">
                    Taxable<br>
                    <span class="text-muted" style="font-size: 0.75rem;">Subject to tax</span>
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeForm()">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="saveCharge()">
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
